export default {
    PERSONAL_INFO: 1,
    FINANCIAL_INFO: 2,
    MEDIA: 3,
    ACTIVITY_AREA: 4,
    STORE_INFO: 5,
    IMPLEMENT_SCRIPT: 6,
    SUBMIT_COMMISSION: 7,
    CHARGE_ACCOUNT: 8,
    ACCEPT_AGREEMENT: 9,
    PENDING_TO_ACTIVE: 10,
    COMPLETE: 0,
    SUSPENDED: 100,
}